import React from "react";
import { Spinner } from "@diverge/ui/components/spinner";

function AuthLoadingScreen({
  ariaLabel = "Loading authentication status",
  message = "Checking sign-in status...",
}) {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background px-6">
      <div className="flex flex-col items-center gap-5 text-center">
        <div className="flex items-center justify-center">
          <img src="/svgs/diverge-black.svg" alt="Diverge" className="h-8 w-auto" />
          <img src="/svgs/diverge-white.svg" alt="Diverge" className="hidden h-8 w-auto" />
        </div>
        <Spinner aria-label={ariaLabel} size="lg" className="text-primary-text" />
        <p className="text-sm text-muted-foreground">{message}</p>
      </div>
    </div>
  );
}

export default AuthLoadingScreen;
